
import apiClient from '@/conf/axiosConfig';
import LoadingPage from '@/views/LoadingPage.vue';
import LoadingPageDesktop from '@/views/LoadingPageDesktop.vue';
import Cookies from 'js-cookie';
import UAParser from 'ua-parser-js';
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { LocationQuery, useRoute } from 'vue-router';

export default defineComponent({
  props: {
    isShortUrl: {
      type: Boolean,
      default: false,
    },
    isViber: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
    },
  },
  setup(props) {
    const isLoadingDone = ref(false);
    const buttonUrl = ref('');
    const logoGuid = ref('');
    const isMobile = ref(false);
    const route = useRoute();
    const currentParam = ref(route.params.param);
    const allQueryParams = ref(route.query);
    const parts = navigator.language.split('-');
    const countryCode = parts.length > 1 ? parts[1] : parts[0];
    const disclaimerGuid = ref<string | null>(
      Cookies.get('disclaimerGuid') ?? null
    );
    const parser = new UAParser();
    const result = parser.getResult();
    const userAgentString = ref('');
    const browserInfo = `${result.browser.name} ${result.browser.version}`;
    const osInfo = `${result.os.name} ${result.os.version}`;
    const deviceInfo = `${result.device.type || 'n/a'} ${
      result.device.vendor || ''
    } ${result.device.model || ''}`.trim();
    userAgentString.value = `${browserInfo}; ${osInfo}; ${deviceInfo}`;
    const getGuidCookie = () => {
      if (!disclaimerGuid.value) {
        // Generieren eines neuen GUID-Werts
        disclaimerGuid.value = (
          Math.random().toString(36).substring(2, 6) +
          Math.random().toString(36).substring(2, 6)
        ).toUpperCase();
        // Setzen des neuen Wertes als Cookie
        Cookies.set('disclaimerGuid', disclaimerGuid.value);
      }
    };
    const checkDeviceType = () => {
      const parser = new UAParser();
      const result = parser.getResult();
      isMobile.value = result.device.type === 'mobile';
    };
    onMounted(() => {
      checkDeviceType();
      getGuidCookie();
      callApiAndRedirect();
      window.addEventListener('resize', checkDeviceType);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkDeviceType);
    });
    const callApiAndRedirect = async () => {
      try {
        const channelType = props.isViber ? 'VIBER' : 'WB';
        const allQueryParamsCopy: LocationQuery = {};
        Object.entries(allQueryParams.value).forEach(([key, value]) => {
          allQueryParamsCopy[key] = value;
        });
        if ('PY' !== props.source) {
          allQueryParamsCopy['apiCall'] = 'true';
          allQueryParamsCopy['extCall'] = 'true';
        }
        const request = {
          id: currentParam.value,
          params: JSON.stringify(allQueryParamsCopy),
          metaDto: {
            languageCode: navigator.language.substring(0, 2).toLowerCase(),
            webhookType: 'THREESIXTY_DIALOG',
            mobile: isMobile.value,
            userAgent: navigator.userAgent,
            countryCode: countryCode.toLowerCase(),
            platformType: 'IOS',
            paramsUnformatted: convertQueryToString(allQueryParams.value),
            channelType: channelType,
            disclaimerGuid: disclaimerGuid.value,
            source: props.source,
          },
        };
        apiClient
          .post('api/dispatch/v1', request)
          .then((response) => {
            buttonUrl.value = response.data.targetUrl;
            logoGuid.value = response.data.logoGuid;
            if (!response.data.redirect) {
              isLoadingDone.value = true;
            }
            if (isMobile.value && response.data.openMessenger) {
              //window.location.href = response.data.targetUrl;
              window.open(response.data.targetUrl, '_blank');
            }

            if (response.data.redirect) {
              window.location.href = response.data.targetUrl;
            }
          })
          .catch((error) => {
            // Fehlerbehandlung
            console.error('API-Fehler:', error);
          })
          .finally();
        {
        }
      } catch (error) {
        console.error('Fehler beim Abrufen der API-Daten:', error);
      }
    };
    function convertQueryToString(query: LocationQuery): string {
      const queryParams = new URLSearchParams();
      Object.keys(query).forEach((key) => {
        const value = query[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item !== null) {
              queryParams.append(key, item);
            }
          });
        } else if (value !== null) {
          queryParams.append(key, value);
        }
      });
      return queryParams.toString();
    }
    return { isLoadingDone, buttonUrl, isMobile, logoGuid };
  },
  components: { LoadingPage, LoadingPageDesktop },
});
